import { registerBlockType } from '@wordpress/blocks';
import metadata from './block.json';
import Edit from './Edit';
import Save from './save';

registerBlockType( metadata.name, {
	edit: Edit,
	save: Save,
	icon: {
		foreground: '#0061FE',
		src: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 24 24"
				width="24"
				height="24"
			>
				{ /* One slot, its alternates stacked behind it. */ }
				<rect
					x="7"
					y="4"
					width="14"
					height="5"
					rx="1"
					fill="currentColor"
					opacity=".25"
				/>
				<rect
					x="5"
					y="10"
					width="14"
					height="5"
					rx="1"
					fill="currentColor"
				/>
				<rect
					x="3"
					y="16"
					width="14"
					height="5"
					rx="1"
					fill="currentColor"
					opacity=".25"
				/>
			</svg>
		),
	},
} );
